import { useEffect } from 'react';

// Global 3D tilt: any element with class `food-card` or `tilt-card` reacts to the cursor.
export default function Tilt3D() {
  useEffect(() => {
    let current = null;

    const reset = (el) => {
      el.style.transition = 'transform 0.5s ease, box-shadow 0.5s ease, border-color 0.5s ease';
      el.style.transform = '';
      el.style.boxShadow = '';
      el.style.borderColor = '';
      const glare = el.querySelector('.tilt-glare');
      if (glare) glare.style.opacity = '0';
    };

    const onMove = (e) => {
      const el = e.target.closest('.food-card, .tilt-card');
      if (!el) {
        if (current) { reset(current); current = null; }
        return;
      }
      if (current && current !== el) reset(current);
      current = el;

      const r = el.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width;
      const py = (e.clientY - r.top) / r.height;
      const rx = (0.5 - py) * 11;
      const ry = (px - 0.5) * 13;

      el.style.transition = 'transform 0.08s ease-out, box-shadow 0.3s ease, border-color 0.3s ease';
      el.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg) translateY(-6px) scale(1.02)`;
      el.style.boxShadow = '0 28px 55px -14px rgba(249,115,22,0.5)';
      el.style.borderColor = 'rgba(249,115,22,0.65)';

      const glare = el.querySelector('.tilt-glare');
      if (glare) {
        glare.style.opacity = '1';
        glare.style.background = `radial-gradient(circle at ${px * 100}% ${py * 100}%, rgba(255,255,255,0.22), transparent 45%)`;
      }
    };

    document.addEventListener('pointermove', onMove, { passive: true });
    return () => document.removeEventListener('pointermove', onMove);
  }, []);

  return null;
}
